import styled from 'styled-components';
import colors from 'constants/colors';

export const Container = styled.div`
  width: 100%;  
  background-color: ${colors.black1};
  display: flex;
  flex-direction: column;
  align-items: center;
  color: ${colors.silver};
  padding: 15px;

  @media only screen and (min-width: 1200px) {
    display: none;
  }
`;

export const ViewingContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  letter-spacing: 1px;
`;

export const RemainingContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  letter-spacing: 1px;
  margin-top: 25px;
`;

export const Title = styled.div`
  width: 100%;
  font-size: 22px;
  font-weight: 300;
  color: ${colors.silver};
  margin-bottom: 10px;

  @media only screen and (max-width: 767px) {
    font-size: 19px;
  }
`;

export const RemainingItem = styled.div`
  width: 100%;
  padding: 5px 0;
  margin-bottom: 10px;
  border-bottom: 1px solid ${colors.charcoal};
  cursor: pointer;

  div {
    letter-spacing: 0.5px;
    font-size: 15px;
    color: ${colors.white};

    :nth-child(1) {
      font-weight: 300;
    }

    :nth-child(2) {
      font-weight: 600;
    }

    @media only screen and (max-width: 767px) {
      font-size: 13px;
    }
  }

  ${({ additionalstyle }) => additionalstyle};
`;
